import { GET_DEVICE_LIST } from '../actions'

const INITIAL_STATE = {}

function DeviceListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_DEVICE_LIST:
            return action.payload.body
        default: return state
    }
}

export default DeviceListReducer



// WEBPACK FOOTER //
// ./src/reducers/deviceList.js